import { useQuery } from "@tanstack/react-query";
import { get } from "./divertidogsApiUtils";

export type NivelActividad = "COMUN" | "IMPORTANTE" | "URGENTE";

export interface LogActividad {
  id: string;
  tipo: string;
  nivel: NivelActividad;
  descripcion: string;
  tiempoGeneracion: string;
  segundosTranscurridos: number;
}

export const QUERY_OBTENER_ULTIMOS_LOGS_ACTIVIDADES =
  "QUERY_OBTENER_ULTIMOS_LOGS_ACTIVIDADES";

export const useObtenerUltimosLogsActividades = () =>
  useQuery(
    [QUERY_OBTENER_ULTIMOS_LOGS_ACTIVIDADES],
    async () => await obtenerUltimosLogsActividades()
  );

export const obtenerUltimosLogsActividades = async () => {
  return get<LogActividad[]>(`log_actividades/ultimas`);
};
